<div class="modal-header">
  <h3 class="modal-title"> {{ 'No product on stock' | translate }}</h3>
  <button type="button" class="close" (click)="onCloseClick()">
    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body" style="display: block; max-height: 88%;">
  <p>{{ 'The selected products have been sold and are not available in stock' | translate }}</p>
  <span *ngFor="let locationId of locationIds">
    <br>
    <h4>
      {{ getLocationName(locationId) | translate }}:
    </h4>
    <h4 *ngFor="let item of getProductsStockInformationByLocation(locationId)">
      {{ item.productName | translate }} {{ 'available' | translate }} {{ item.availableQuantity }} {{ 'of' | translate
      }} {{ item.quantity }}
    </h4>
  </span>
</div>
<div class="modal-footer justify-content-between" style="padding: 0px;padding-top: 10px;text-align: center;">
  <div class="col-12">
    <button type="button" class="btn btn-primary btn-dialog" [mat-dialog-close]="true" cdkFocusInitial>
      {{ 'Confirm' | translate }}
    </button>
  </div>
</div>
